<template>
    <div class="request-container">
        <h3 class="title">{{ $t('modals.patient_profile.profile.request.card_head') }}</h3>

        <request-tabs @toggle="toggleTab"></request-tabs>

        <div class="tab-content">
            <request-tab-content
                :physician="{
                    NetworkTab: isNetworkTabActive,
                    EmailTabs: isEmailTabActive,
                    HipaaTab: isHipaaTabActive,
                }"
                @toggle="toggleTab"
            ></request-tab-content>
        </div>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import RequestTabs from 'components/forms/patient/RequestTabs'
    import RequestTabContent from 'components/forms/patient/RequestTabContent'

    export default {
        name: 'request-records-form',
        mixins: [FormMixin, HandleRequestMixin],
        components: {
            RequestTabs,
            RequestTabContent,
        },
        data() {
            return {
                isNetworkTabActive: true,
                isEmailTabActive: false,
                isHipaaTabActive: false,
            }
        },
        methods: {
            toggleTab(name) {
                this.isNetworkTabActive = false
                this.isEmailTabActive = false
                this.isHipaaTabActive = false
                switch (name) {
                    case 'network':
                        this.isNetworkTabActive = true
                        break
                    case 'email':
                        this.isEmailTabActive = true
                        break
                    case 'hipaa':
                        this.isHipaaTabActive = true
                        break
                }
            },
        },
    }
</script>
